import { Form as FormikForm } from 'formik';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  background: linear-gradient(155.18deg, #1d2526 -0.81%, #1d2526 16.33%, #000 118.11%);
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const Image = styled.img`
  max-width: 100px;
  @media screen and (max-height: 1280px) {
    max-width: 14vh;
    max-height: 120px;
  }
`;

export const Form = styled(FormikForm)`
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 576px) {
    max-width: 540px;
  }
  width: 100%;
  margin-right: auto;
  margin-left: auto;
`;

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3vh;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
`;

export const WrapperForgot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 32px;
  color: #ffc033;
  font-family: 'Gentleman', Arial, sans-serif;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
